import { useEffect, useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { BOOKING_MODES } from "pagesV2/pro/Bookings/constants"
import { fetchExperienceById } from "store/experiences"

export const EXPERIENCE_FAILED = "failed"

// The experiences behind the cart's items, shared by the cart and checkout: { [id]: experience },
// or EXPERIENCE_FAILED when one can't be loaded (removed, unpublished). The one the experience page
// left in the store is used as is; each missing one is requested once, even if the cart changes
// while it loads.
const useCartExperiences = (items) => {
  const dispatch = useDispatch()
  const { experienceDetail } = useSelector((state) => state.experiences.experienceById)
  const [loaded, setLoaded] = useState({})
  const experiences = useMemo(
    () => (experienceDetail?.uuid ? { [experienceDetail.uuid]: experienceDetail, ...loaded } : loaded),
    [experienceDetail, loaded]
  )
  const missingIds = useMemo(() => [...new Set(items.map((item) => item.experienceId))].filter((id) => !experiences[id]), [items, experiences])
  const requestedIdsRef = useRef(new Set())

  useEffect(() => {
    missingIds
      .filter((id) => !requestedIdsRef.current.has(id))
      .forEach((id) => {
        requestedIdsRef.current.add(id)
        dispatch(fetchExperienceById(id, undefined, BOOKING_MODES.embedded))
          .then((response) => setLoaded((prev) => ({ ...prev, [id]: response?.data || EXPERIENCE_FAILED })))
          .catch(() => setLoaded((prev) => ({ ...prev, [id]: EXPERIENCE_FAILED })))
      })
  }, [missingIds, dispatch])

  return experiences
}

export default useCartExperiences
